export default function shareUrl(url) {
  /*
  // Поддержка нативного шаринга
  if (navigator.share && navigator.canShare && navigator.canShare({ url })) {
    navigator
      .share({
        url: url,
      })
      .catch((error) => {
        console.error(error);
      });
    return;
  }
  */

  // Fallback: кастомное окно шаринга
  createShareModal(url);
}

function createShareModal(url) {
  const existingModal = document.querySelector(".share-popup-overlay");
  if (existingModal) {
    existingModal.remove();
  }

  const isLangRu = document.body.classList.contains('lang-ru');
  const isLangKk = document.body.classList.contains('lang-kk');

  let title;

  if (isLangRu) {
    title = "Поделиться:";
  }

  if (isLangKk) {
    title = "Бөлісу:";
  }

  const encodedUrl = encodeURIComponent(url);

  const modal = document.createElement("div");
  modal.classList.add("share-popup-overlay");
  modal.innerHTML = `
    <div class="share-popup">
      <button class="share-close">✕</button>
      <h3 class="share-title">${title}</h3>
      <div class="share-buttons">
        <button class="share-btn copy">
          <img src="/images/share-copy.svg" height="45"/>
        </button>

        <a href="https://wa.me/?text=${encodedUrl}"
          target="_blank"
          class="share-btn whatsapp">
          <img src="/images/share-whatsapp.svg" height="45"/>
        </a>

        <a href="https://t.me/share/url?url=${encodedUrl}"
          target="_blank"
          class="share-btn telegram">
          <img src="/images/share-telegram.svg" width="45"/>
        </a>
      </div>
    </div>
  `;

  /*
  <a href="https://twitter.com/intent/tweet?url=${encodedUrl}"
    target="_blank"
    class="share-btn twitter">
    <img src="/images/share-x.svg" width="45"/>
  </a>
  */

  document.body.appendChild(modal);

  const closeBtn = modal.querySelector(".share-close");
  const copyBtn = modal.querySelector(".share-btn.copy");

  closeBtn.addEventListener("click", () => {
    modal.remove();
  });

  copyBtn.addEventListener("click", () => {
    copyToClipboard(url, copyBtn);
  });
}

function copyToClipboard(url, buttonElement) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        showCopySuccess(buttonElement);
      })
      .catch((err) => {
        fallbackCopyToClipboard(url, buttonElement);
      });
  } else {
    fallbackCopyToClipboard(url, buttonElement);
  }
}

function fallbackCopyToClipboard(url, buttonElement) {
  const textArea = document.createElement("textarea");
  textArea.value = url;
  textArea.style.position = "fixed";
  textArea.style.left = "-9999px";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand("copy");
    showCopySuccess(buttonElement);
  } catch (err) {
    console.error("Не удалось скопировать:", err);
    alert("Не удалось скопировать ссылку");
  }

  document.body.removeChild(textArea);
}

function showCopySuccess(buttonElement) {
  const originalText = buttonElement.textContent;
  buttonElement.textContent = "Скопировано!";
  buttonElement.style.opacity = "0.7";

  setTimeout(() => {
    buttonElement.textContent = originalText;
    buttonElement.style.opacity = "1";
  }, 2000);
}
